import { Colour_Tournament } from "./Utils";

export class PositionMatchStats {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "PositionMatchStats";
    this.scene = "PositionMatchStats";
    this.data = [];
    this.page = 7055;
  }

  async preview({ options }) {
    this.onAir = false;
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = Colour_Tournament({ game: options.game, xml });

      // if (options.push_up) {
      //   xml.payload.field.find((item) => {
      //     return item.attr.name === "0000";
      //   }).value = "1";
      // } else {
      try {
        xml.payload.field.find((item) => {
          return item.attr.name === "0000";
        }).value = "0";
      } catch (err) {}
      // }

      xml.payload.field.find((item) => {
        return item.attr.name === "006";
      }).value =
        options.game?.home_team?.variables?.alt_badge ||
        options.game?.home_team?.variables?.badge;

      xml.payload.field.find((item) => {
        return item.attr.name === "007";
      }).value =
        options.game?.away_team?.variables?.alt_badge ||
        options.game?.away_team?.variables?.badge;

      xml.payload.field.find((item) => {
        return item.attr.name === "0000106";
      }).value = "Match stats";

      if (options.position === "outside_backs") {
        let outside_backs = options?.game?.lineup?.home
          ?.concat(options?.game?.lineup?.away)
          ?.filter((p) => {
            return (
              p?.order === 1 ||
              p?.order === 2 ||
              p?.order === 3 ||
              p?.order === 4 ||
              p?.order === 5
            );
          });

        let home_player_stats = options?.game?.opta_home_player_stats?.filter(
          (p) => {
            return (
              outside_backs?.findIndex(
                (o) => o?.squad?.player?.opta_ID === p?.player,
              ) > -1
            );
          },
        );

        let away_player_stats = options?.game?.opta_away_player_stats?.filter(
          (p) => {
            return (
              outside_backs?.findIndex(
                (o) => o?.squad?.player?.opta_ID === p?.player,
              ) > -1
            );
          },
        );

        xml.payload.field.find((item) => {
          return item.attr.name === "0000104";
        }).value = "Outside Backs";

        xml.payload.field.find((item) => {
          return item.attr.name === "0101";
        }).value = "Carries";

        xml.payload.field.find((item) => {
          return item.attr.name === "0102";
        }).value = home_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["carries"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0103";
        }).value = away_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["carries"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0201";
        }).value = "Metres";

        xml.payload.field.find((item) => {
          return item.attr.name === "0202";
        }).value =
          home_player_stats?.reduce((prev, curr) => {
            return prev + (parseInt(curr?.stats?.["metres"]) || 0);
          }, 0) + "m";

        xml.payload.field.find((item) => {
          return item.attr.name === "0203";
        }).value =
          away_player_stats?.reduce((prev, curr) => {
            return prev + (parseInt(curr?.stats?.["metres"]) || 0);
          }, 0) + "m";

        xml.payload.field.find((item) => {
          return item.attr.name === "0301";
        }).value = "Tackle breaks";

        xml.payload.field.find((item) => {
          return item.attr.name === "0302";
        }).value = home_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["tackle_busts"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0303";
        }).value = away_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["tackle_busts"]) || 0);
        }, 0);
      } else if (options.position === "props") {
        let props = options?.game?.lineup?.home
          ?.concat(options?.game?.lineup?.away)
          ?.filter((p) => {
            return p?.order === 8 || p?.order === 10 || p?.order === 13;
          });

        let home_player_stats = options?.game?.opta_home_player_stats?.filter(
          (p) => {
            return (
              props?.findIndex((o) => o?.squad?.player?.opta_ID === p?.player) >
              -1
            );
          },
        );

        let away_player_stats = options?.game?.opta_away_player_stats?.filter(
          (p) => {
            return (
              props?.findIndex((o) => o?.squad?.player?.opta_ID === p?.player) >
              -1
            );
          },
        );

        xml.payload.field.find((item) => {
          return item.attr.name === "0000104";
        }).value = "Middles";

        xml.payload.field.find((item) => {
          return item.attr.name === "0101";
        }).value = "Carries";

        xml.payload.field.find((item) => {
          return item.attr.name === "0102";
        }).value = home_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["carries"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0103";
        }).value = away_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["carries"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0201";
        }).value = "Metres";

        xml.payload.field.find((item) => {
          return item.attr.name === "0202";
        }).value =
          home_player_stats?.reduce((prev, curr) => {
            return prev + (parseInt(curr?.stats?.["metres"]) || 0);
          }, 0) + "m";

        xml.payload.field.find((item) => {
          return item.attr.name === "0203";
        }).value =
          away_player_stats?.reduce((prev, curr) => {
            return prev + (parseInt(curr?.stats?.["metres"]) || 0);
          }, 0) + "m";

        xml.payload.field.find((item) => {
          return item.attr.name === "0301";
        }).value = "Offloads";

        xml.payload.field.find((item) => {
          return item.attr.name === "0302";
        }).value = home_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["offloads"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0303";
        }).value = away_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["offloads"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0401";
        }).value = "Tackles";

        xml.payload.field.find((item) => {
          return item.attr.name === "0402";
        }).value = home_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["tackles"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0403";
        }).value = away_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["tackles"]) || 0);
        }, 0);
      } else if (options.position === "half_backs") {
        let props = options?.game?.lineup?.home
          ?.concat(options?.game?.lineup?.away)
          ?.filter((p) => {
            return p?.order === 6 || p?.order === 7;
          });

        let home_player_stats = options?.game?.opta_home_player_stats?.filter(
          (p) => {
            return (
              props?.findIndex((o) => o?.squad?.player?.opta_ID === p?.player) >
              -1
            );
          },
        );

        let away_player_stats = options?.game?.opta_away_player_stats?.filter(
          (p) => {
            return (
              props?.findIndex((o) => o?.squad?.player?.opta_ID === p?.player) >
              -1
            );
          },
        );

        xml.payload.field.find((item) => {
          return item.attr.name === "0000104";
        }).value = "Half Backs";

        xml.payload.field.find((item) => {
          return item.attr.name === "0101";
        }).value = "Carries";

        xml.payload.field.find((item) => {
          return item.attr.name === "0102";
        }).value = home_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["carries"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0103";
        }).value = away_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["carries"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0201";
        }).value = "Passes";

        xml.payload.field.find((item) => {
          return item.attr.name === "0202";
        }).value = home_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["passes"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0203";
        }).value = away_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["passes"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0301";
        }).value = "Line break assists";

        xml.payload.field.find((item) => {
          return item.attr.name === "0302";
        }).value = home_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["break_assist"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0303";
        }).value = away_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["break_assist"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0401";
        }).value = "Kicks in general play";

        xml.payload.field.find((item) => {
          return item.attr.name === "0402";
        }).value = home_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["kicks_in_gen_play"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0403";
        }).value = away_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["kicks_in_gen_play"]) || 0);
        }, 0);
      } else if (options.position === "back_row") {
        let props = options?.game?.lineup?.home
          ?.concat(options?.game?.lineup?.away)
          ?.filter((p) => {
            return p?.order === 11 || p?.order === 12;
          });

        let home_player_stats = options?.game?.opta_home_player_stats?.filter(
          (p) => {
            return (
              props?.findIndex((o) => o?.squad?.player?.opta_ID === p?.player) >
              -1
            );
          },
        );

        let away_player_stats = options?.game?.opta_away_player_stats?.filter(
          (p) => {
            return (
              props?.findIndex((o) => o?.squad?.player?.opta_ID === p?.player) >
              -1
            );
          },
        );

        xml.payload.field.find((item) => {
          return item.attr.name === "0000104";
        }).value = "Second Rows";

        xml.payload.field.find((item) => {
          return item.attr.name === "0101";
        }).value = "Carries";

        xml.payload.field.find((item) => {
          return item.attr.name === "0102";
        }).value = home_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["carries"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0103";
        }).value = away_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["carries"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0201";
        }).value = "Metres";

        xml.payload.field.find((item) => {
          return item.attr.name === "0202";
        }).value =
          home_player_stats?.reduce((prev, curr) => {
            return prev + (parseInt(curr?.stats?.["metres"]) || 0);
          }, 0) + "m";

        xml.payload.field.find((item) => {
          return item.attr.name === "0203";
        }).value =
          away_player_stats?.reduce((prev, curr) => {
            return prev + (parseInt(curr?.stats?.["metres"]) || 0);
          }, 0) + "m";

        xml.payload.field.find((item) => {
          return item.attr.name === "0301";
        }).value = "Offloads";

        xml.payload.field.find((item) => {
          return item.attr.name === "0302";
        }).value = home_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["offloads"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0303";
        }).value = away_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["offloads"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0401";
        }).value = "Tackles";

        xml.payload.field.find((item) => {
          return item.attr.name === "0402";
        }).value = home_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["tackles"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0403";
        }).value = away_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["tackles"]) || 0);
        }, 0);
      } else if (options.position === "hooker") {
        let props = options?.game?.lineup?.home
          ?.concat(options?.game?.lineup?.away)
          ?.filter((p) => {
            return p?.order === 9;
          });

        let home_player_stats = options?.game?.opta_home_player_stats?.filter(
          (p) => {
            return (
              props?.findIndex((o) => o?.squad?.player?.opta_ID === p?.player) >
              -1
            );
          },
        );

        let away_player_stats = options?.game?.opta_away_player_stats?.filter(
          (p) => {
            return (
              props?.findIndex((o) => o?.squad?.player?.opta_ID === p?.player) >
              -1
            );
          },
        );

        xml.payload.field.find((item) => {
          return item.attr.name === "0000104";
        }).value = "Hookers";

        xml.payload.field.find((item) => {
          return item.attr.name === "0101";
        }).value = "Passes";

        xml.payload.field.find((item) => {
          return item.attr.name === "0102";
        }).value = home_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["passes"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0103";
        }).value = away_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["passes"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0201";
        }).value = "Metres from dummy half";

        xml.payload.field.find((item) => {
          return item.attr.name === "0202";
        }).value =
          home_player_stats?.reduce((prev, curr) => {
            return prev + (parseInt(curr?.stats?.["dummy_half_metres"]) || 0);
          }, 0) + "m";

        xml.payload.field.find((item) => {
          return item.attr.name === "0203";
        }).value =
          away_player_stats?.reduce((prev, curr) => {
            return prev + (parseInt(curr?.stats?.["dummy_half_metres"]) || 0);
          }, 0) + "m";

        xml.payload.field.find((item) => {
          return item.attr.name === "0301";
        }).value = "Kicks in general play";

        xml.payload.field.find((item) => {
          return item.attr.name === "0302";
        }).value = home_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["kicks_in_gen_play"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0303";
        }).value = away_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["kicks_in_gen_play"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0401";
        }).value = "Tackles";

        xml.payload.field.find((item) => {
          return item.attr.name === "0402";
        }).value = home_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["tackles"]) || 0);
        }, 0);

        xml.payload.field.find((item) => {
          return item.attr.name === "0403";
        }).value = away_player_stats?.reduce((prev, curr) => {
          return prev + (parseInt(curr?.stats?.["tackles"]) || 0);
        }, 0);
      }

      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
